import { EMPTY_VALUE } from '@/constants/ui'

import * as S from './field-row.styled'
import type { FieldViewValueProps } from './field-row.types'

export const FieldViewValue = ({ children }: FieldViewValueProps) => (
  <S.FieldValue $isViewOnly>{children || EMPTY_VALUE}</S.FieldValue>
)
